import React, { Component } from 'react';

class Banner extends Component {
	render() {
		return (
			<section className="review">
				<div className="review__section">
					<div className="review__section__filter text-center">
						<div className="row">
							<div className="col-md-6 d-none d-md-block">
								<input type="text" className="form-control search" placeholder="Search" />
							</div>
							<div className="col-6 col-md-3">
								<select className="form-control select">
									<option selected>Skin Concern</option>
									<option value="1">Body Concern</option>
									<option value="2">Arm Concern</option>
								</select>
							</div>
							<div className="col-6 col-md-3">
								<select className="form-control select">
									<option selected>Oily</option>
									<option value="1">Dry</option>
								</select>
							</div>
						</div>
					</div>
				</div>
				<div className="review__section">
					<div className="rating">
						<div className="d-flex flex-sm-row flex-column">
							<div className="buyer buyer__info">
								<div className="rating__stars">
									<img src="/images/5-start.svg" />
								</div>
								<p>Julia, Singapore</p>
							</div>
							<div className="rating__review">
								<h3 className="rating__review__title mt-3">I fell in love with yours from day one!</h3>
								<p>“It's not that I wasn't pretty. It’s that I wasn’t confident enough to see myself that way.”“It's not that I wasn't pretty. It’s that I wasn’t confident enough to see myself that way.”“It's not that I wasn't pretty.</p>
							</div>
						</div>
					</div>
					<div className="rating">
						<div className="d-flex flex-sm-row flex-column">
							<div className="buyer buyer__info">
								<div className="rating__stars">
									<img src="/images/5-start.svg" />
								</div>
								<p>Julia, Singapore</p>
							</div>
							<div className="rating__review">
								<h3 className="rating__review__title mt-3">I fell in love with yours from day one!</h3>
								<p>“It's not that I wasn't pretty. It’s that I wasn’t confident enough to see myself that way.”“It's not that I wasn't pretty. It’s that I wasn’t confident enough to see myself that way.”“It's not that I wasn't pretty.</p>
							</div>
						</div>
					</div>
					<div className="rating">
						<div className="d-flex flex-sm-row flex-column">
							<div className="buyer buyer__info">
								<div className="rating__stars">
									<img src="/images/5-start.svg" />
								</div>
								<p>Julia, Singapore</p>
							</div>
							<div className="rating__review">
								<h3 className="rating__review__title mt-3">I fell in love with yours from day one!</h3>
								<p>“It's not that I wasn't pretty. It’s that I wasn’t confident enough to see myself that way.”“It's not that I wasn't pretty. It’s that I wasn’t confident enough to see myself that way.”“It's not that I wasn't pretty.</p>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}


export default Banner;